import { render } from "./ChatHub.vue?vue&type=template&id=97bb0822&scoped=true"
import script from "./ChatHub.vue?vue&type=script&lang=js"
export * from "./ChatHub.vue?vue&type=script&lang=js"

import "./ChatHub.vue?vue&type=style&index=0&id=97bb0822&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97bb0822"]])

export default __exports__